export interface BannerVisibilityParams {
  enabled: boolean;
  imageUrl: string;
  isAuthenticated: boolean;
  reshowDays: number;
  /** Today as 'YYYY-MM-DD'. */
  todayISO: string;
  /** Stored dismiss date 'YYYY-MM-DD', or null if never dismissed (days mode). */
  lastDismissISO: string | null;
  /** Whether the banner was already dismissed in this browser session (session mode). */
  dismissedThisSession: boolean;
}

/** Whole-days elapsed between two 'YYYY-MM-DD' dates (b - a). */
function daysBetween(aISO: string, bISO: string): number {
  const a = Date.parse(`${aISO}T00:00:00Z`);
  const b = Date.parse(`${bISO}T00:00:00Z`);
  if (Number.isNaN(a) || Number.isNaN(b)) return Number.POSITIVE_INFINITY;
  return Math.floor((b - a) / 86_400_000);
}

/**
 * Decide whether the welcome banner should be shown.
 * Gates: enabled + has image + visitor not authenticated.
 * Re-show: reshowDays===0 → once per session; >=1 → once every N days.
 */
export function shouldShowBanner(params: BannerVisibilityParams): boolean {
  const { enabled, imageUrl, isAuthenticated, reshowDays, todayISO, lastDismissISO, dismissedThisSession } = params;
  if (!enabled || !imageUrl || isAuthenticated) return false;

  if (reshowDays === 0) {
    return !dismissedThisSession;
  }
  if (!lastDismissISO) return true;
  return daysBetween(lastDismissISO, todayISO) >= reshowDays;
}
